import { useIsMobile } from '~/context/common/DeviceContext';
import { useIsInExperiment } from '~/hooks/common';

const useIsInMobileStickyNavExperiment = () => {
  const isInStickyNavExperiment = useIsInExperiment(
    'vdp-mobile-sticky-nav',
    'experiment'
  );
  const isMobile = useIsMobile();

  return isInStickyNavExperiment && isMobile;
};

export default useIsInMobileStickyNavExperiment;
